import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyBxEsR-rUqeQ3es_9Toj6y5WSPDLJHC81Y",
    authDomain: "jeu-web-syntilor.firebaseapp.com",
    projectId: "jeu-web-syntilor",
    storageBucket: "jeu-web-syntilor.appspot.com",
    messagingSenderId: "365584779170",
    appId: "1:365584779170:web:92c2c19b595be5fa35d4fb"
};

const firebaseApp = initializeApp(firebaseConfig);

export const db = getFirestore(firebaseApp);
export default firebaseApp;